import angular from 'angular';

import pages from '@angular/dashboard/manage/pages';
import users from '@angular/dashboard/manage/users';
import groups from '@angular/dashboard/manage/groups';
import locations from '@angular/dashboard/manage/locations';
import positions from '@angular/dashboard/manage/positions';
import tags from '@angular/dashboard/manage/tags';
import announcements from '@angular/dashboard/manage/announcements';
import feedback from '@angular/dashboard/manage/feedback';
import manageGroupHeaderComponent from '@angular/dashboard/manage/components/manageGroupHeaderComponent';
import { accessLevels } from '@angular/constants';

const manageModule = angular.module('sling.dashboard.manage', [
  pages,
  users,
  groups,
  locations,
  positions,
  announcements,
  feedback,
  tags,
]);

manageModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage', {
    abstract: true,
    url: '/manage',
    template: '<ui-view></ui-view>',
    data: {
      title: 'Manage',
      access: accessLevels.manager,
    },
  });
});

manageModule.component('manageGroupHeader', manageGroupHeaderComponent);

export default manageModule.name;
